import { render, staticRenderFns } from "./EntregaResultado.vue?vue&type=template&id=6cb7879a&"
import script from "./EntregaResultado.vue?vue&type=script&lang=js&"
export * from "./EntregaResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports